import React, {Component, useEffect, useState} from 'react';
import { connect } from 'react-redux';

import {useHistory, withRouter} from "react-router-dom";
import ApplicationLogo from "../../assets/Application.png";
import TitleBox from "../title-box";

import "./finish.css";
import {_getPolicy} from "../../store/policy/service";
import {_getSite, _getStep, _setStep} from "../../store/system/service";
import Leftnav from "../template/leftnav";
import Header from "../template/header";
import Template from "../template";
import Button from "../../ui/components/buttons/button";
import {_gaPushData, _gaPushEvent, _getOccupationDesc} from "../../utils/utility"

const Finish = (props) => {
    const annualTurnoverOptions = [
        {
            "text": "Up to $1,000,000",
            "value": "1"
        },
        {
            "text": "$1,000,001 to $2,000,000",
            "value": "2"
        },
        {
            "text": "$2,000,001 to $3,000,000",
            "value": "3"
        },
        {
            "text": "$3,000,001 to $4,000,000",
            "value": "4"
        },
        {
            "text": "$4,000,001 to $5,000,000",
            "value": "5"
        },
        {
            "text": "$5,000,001 to $6,000,000",
            "value": "6"
        },
        {
            "text": "$6,000,001 to $7,000,000",
            "value": "7"
        },
        {
            "text": "$7,000,001 to $8,000,000",
            "value": "8"
        },
        {
            "text": "$8,000,001 to $9,000,000",
            "value": "9"
        },
        {
            "text": "$9,000,001 to $11,000,000",
            "value": "10"
        },
        {
            "text": "$11,000,001 to $13,000,000",
            "value": "11"
        },
        {
            "text": "$13,000,001 to $15,000,000",
            "value": "12"
        },
        {
            "text": "$15,000,001 to $17,000,000",
            "value": "13"
        },
        {
            "text": "$17,000,001 to $19,000,000",
            "value": "14"
        },
        {
            "text": "$19,000,001 to $20,000,000",
            "value": "15"
        }
    ];

    const getAnnualTurnoverOption = (value) => {
         let matches = annualTurnoverOptions.filter((item) => {
            return item.value == value;
         })
         return matches[0] || 'N/A';
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        props.setStep(4);

        // Google Analytics
        if(!!props.policy){
            const category = props.policy.policySME.occupationCode == '785405' ? 'Office' : 'Retail';
            const occupationDescription = props.policy.policySME.occupationCode == '785405' ? 'Office' : 'Retail - ' + props.policy.policySME.businessType;
        
            _gaPushData({
                'pageStep': 'Insured',
                'vPath': '/insured',
                'event': 'vpageview',
                'ecommerce': {
                  'purchase': {
                    'actionField': {
                      'id': props.policy.policyNumber,                   
                      'affiliation': props.policy.agentCode,	            
                      'revenue': props.policy.policySME.totalDueAmount,
                      'coupon': props.policy.promotionCode || 'N/A'                                   
                    },
                    'products': [{                                    
                        'name': 'SME Business Insurance',                       
                        'variant': 'SMEBIZ',                          
                        'price': props.policy.policySME.totalDueAmount,
                        'category': _getOccupationDesc(props.policy.policySME.occupationCode),
                        'dimension1': occupationDescription,          
                        'dimension2': props.policy.policySME.businessType,       
                        'dimension3': getAnnualTurnoverOption(props.policy.policySME.situationTurnoverCode)["text"],
                        'dimension4': props.policy.policySME.numberOfEmployees,               
                        'dimension5': props.policy.policySME.annualWages,               
                        'dimension6': props.policy.policySME.contentsSI,
                        'dimension7': capitalize(props.policy.policySME.ownershipType),
                        'dimension8': props.policy.policySME.buildingSI,
                        'dimension9': props.policy.policySME.interestedParty.role ? props.policy.policySME.interestedParty.role : 'None',
                        'quantity': '1',                              
                    }]
                  }
                }
            });
        }
    }, []);
    
    const capitalize = (str) => {
        if (str) {
            const returnStr = str.charAt(0).toUpperCase() + str.slice(1);
            return returnStr;
        }
        return;
    };

    const backToHome = () => {
        _gaPushEvent('BacktoHome');
        console.log('path ' + window.location.pathname);
        let path = window.location.pathname;
        if (props.site) {
            path = path.substring(0, path.indexOf(props.site) + props.site.toString().length)
        }
        else {
            path = path.substring(0, path.indexOf("/", 1));
        }
        localStorage.clear();
        window.location.href = path;
    }

    return (
        <Template payment step={props.step} policy={props.policy} site={props.site} hideBackBtn={true}>
            <TitleBox>Your insurance application has been accepted.</TitleBox>

            <div className="FinishPolicyBoxStyle">
                <div className="FinishPolicyStyle">
                    <div className="FinishPolicyTextStyle">
                        Policy Number: {props.policy.policyNumber}
                    </div>
                </div>
            </div>

            <div className="FinishTextBoxStyle">
                <div className="FinishTextLabelStyle">
                    Receipt Number
                </div>
                <div className="FinishTextValueStyle">
                    {props.policy?.payment?.paymentReferenceNumber || ''}
                </div>
            </div>

            <div className="FinishTextBoxStyle">
                <div className="divider"/>
                <div className="FinishTextLabelStyle">
                    A confirmation email has been sent to
                </div>
                <div className="FinishTextValueStyle">
                    {props.policy?.policySME?.applicant?.email || ''}
                </div>
            </div>

            <div className="FinishTextBoxStyle">
                <div className="FinishButtonsStyle">
                    <Button color="primary" onClick={backToHome}>Back to Home</Button>
                </div>
            </div>
        </Template>
    );
}

// get status from redux (subscription)
const mapStateToProps = (state) => {
    const currPolicy = _getPolicy(state);

    return {
        policy: currPolicy,
        step: _getStep(state),
        site: _getSite(state)
    }
}

// send service request to redux
const mapDispatchToProps = {
    setStep: _setStep
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Finish));
